import SAMLBackendCreate from 'authentication/components/saml/config/SAMLBackendCreate';
import SAMLBackendEdit from 'authentication/components/saml/config/SAMLBackendEdit';
import SAMLBackendConfigDetails from 'authentication/components/saml/config/SAMLBackendConfigDetails';
import SAMLLoginForm from 'authentication/components/saml/SAMLLoginForm';
import { fromConfigJSON, toConfigJSON } from 'authentication/components/saml/config/helpers/samlConfigConverter';

import { AUTH_SERVICE_TYPE } from './constants';

export default {
  routes: [],
  'authentication.services': [
    {
      name: AUTH_SERVICE_TYPE,
      displayName: 'SAML',
      createComponent: SAMLBackendCreate,
      editComponent: SAMLBackendEdit,
      configDetailsComponent: SAMLBackendConfigDetails,
      configFromJson: fromConfigJSON,
      configToJson: toConfigJSON,
    },
  ],
  loginProviderType: [
    {
      type: AUTH_SERVICE_TYPE,
      title: 'SAML',
      formComponent: SAMLLoginForm,
    },
  ],
};
